import { type Api } from "api-client";

import {
  type QuestionnaireFormItem,
  type QuestionnaireFormQuestionnaire,
} from "../components/questionnaireSchema";

export interface ProfileContactFormQuestionnaire extends QuestionnaireFormQuestionnaire {
  id: string;
  name: string;
  description: string;
}

type ProfileContactFormQuestionnaireSource = Pick<
  Api.GetQuestionnaire.Output.Questionnaire,
  "description" | "id" | "items" | "name"
>;

interface NestedQuestionnaireItem extends QuestionnaireFormItem {
  order: number;
  parentItemId: string | null;
  childItems: NestedQuestionnaireItem[];
}

export function getProfileContactFormQuestionnaire(
  questionnaire: ProfileContactFormQuestionnaireSource,
): ProfileContactFormQuestionnaire {
  const itemsById = new Map<string, NestedQuestionnaireItem>();

  for (const item of questionnaire.items) {
    itemsById.set(item.id, {
      ...item,
      childItems: [],
    });
  }

  const rootItems: NestedQuestionnaireItem[] = [];

  for (const item of itemsById.values()) {
    if (item.parentItemId === null) {
      rootItems.push(item);
      continue;
    }

    itemsById.get(item.parentItemId)!.childItems.push(item);
  }

  sortQuestionnaireItems(rootItems);

  return {
    id: questionnaire.id,
    name: questionnaire.name,
    description: questionnaire.description,
    items: rootItems,
  };
}

function sortQuestionnaireItems(items: NestedQuestionnaireItem[]) {
  items.sort((left, right) => {
    return left.order - right.order;
  });

  for (const item of items) {
    sortQuestionnaireItems(item.childItems);
  }
}
